import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { GetCareNowFormatService } from '../../../get-care-now-feature/utilities/getcarenow-format.service';
import { MCAppGatewayService } from '../../../shared/services/mcappgateway/mcappgateway.service';
import { MonitoringService } from '../../../shared/services/monitoring/monitoring-service';
import { SearchStateService } from '../../shared/services/search-state.service';
import { environment } from '../../../../environments/environment';
import { PostGetLocationDetailsRequest } from '../../../shared/model/providerlocationsearch/PostGetLocationDetailRequest';

@Component({
  selector: 'app-location-search-results-card',
  imports: [CommonModule],
  templateUrl: './location-search-results-card.component.html',
  styleUrl: './location-search-results-card.component.css'
})
export class LocationSearchResultsCardComponent {
  @Input() location!: any;
  @Input() currentLocation: any = null;
  @Input() queryCityOrZip!: any;

  public asSoonAsText: string = 'AS_SOON_AS';
  public walkInWait: string = 'WALK_IN_WAIT';
  public milesAwayText: string = 'DESCRIPTION';
  public scheduleText: string = 'SCHEULE';
  public today: string = 'TODAY';
  public tomorrow : string = 'TOMORROW';
  public getDirectionsLabel : string = 'GET_DIRECTIONS';
  public reserveMySpotBtnText: string = 'RESERVE_MY_SPOT';
  public viewDetailBtnText: string = 'NO_AVAILABILITY';
  public vucBtnText: string = '24/7 Virtual Care';
  public currentlyClosedText: string = 'Currently closed';
  public waitTime: string = '';
  public nextAvailabilityFormatted: string = '';
  public isIPUC: boolean = false;
  public is247VUC: boolean = false;
 
  mcAppGateway = inject(MCAppGatewayService);
  searchState = inject(SearchStateService);

  private getCareNowFormatService: GetCareNowFormatService;

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem('locale') || 'en-US'); // Default to 'en-US' if no locale is provided
    this.getCareNowFormatService = new GetCareNowFormatService(this.translate);
  }

  ngOnInit(): void {
  
      this.waitTime = this.getCareNowFormatService.formatWaitTime(this.location.waitTime);
      this.nextAvailabilityFormatted = this.getCareNowFormatService.formatNextAvailability(this.location.nextAvailability);

      this.isIPUC = ((this.location.types ?? "").toUpperCase().includes("URGENT CARE") && this.location.departmentId != null && this.location.departmentId !== "");
      
      // Determine if location is closed and should show 24/7 VUC option
      this.is247VUC = this.location?.isOpen === false;
  
      this.translate.get('WALK_IN_WAIT').subscribe((translated: string) => {
        this.walkInWait = translated;
      });
        
      this.translate.get('BOOK_AS_SOON_AS').subscribe((translated: string) => {
        this.asSoonAsText = translated;
      });
  
      this.translate.get('MILES_AWAY').subscribe((translated: string) => {
        this.milesAwayText = translated;
      });

      this.translate.get('SCHEDULE').subscribe((translated: string) => {
        this.scheduleText = translated;
      });

      this.translate.get('GET_DIRECTIONS').subscribe((translated: string) => {
        this.getDirectionsLabel = translated;
      });

      this.translate.get('RESERVE_MY_SPOT').subscribe((translated: string) => {
        this.reserveMySpotBtnText = translated;
      });

      this.translate.get('VIEW_DETAILS').subscribe((translated: string) => {
        this.viewDetailBtnText = translated;
      });

      this.translate.get('247VUC').subscribe((translated: string) => {
      this.vucBtnText = translated;
    });
  }

  getActionType(): 'view' | 'reserve' | 'virtual' {
    if (this.location?.isOpen === false) {
      return 'virtual';
    } else if (this.location?.nextAvailability) {
      return 'reserve';
    }
    return 'view';
  }

  getActionButtonText(): string {
    const actionType = this.getActionType();
    if (actionType === 'virtual') {
      return this.vucBtnText;
    } else if (actionType === 'reserve') {
      return this.reserveMySpotBtnText;
    }
    return this.viewDetailBtnText;
  }

  onVirtualCareBtnClicked() {
    const eptID = sessionStorage.getItem("eptID");
    if (eptID == null || eptID == undefined || eptID == "") {
      this.vucNowUnAuth();
    }
    else {
      this.vucNowAuth();
    } 
  }

  vucNowUnAuth() {
  
    var deepLink = environment.web_open_scheduling_deep_link_base_url; 
    
    deepLink += "/standalone?id=" + environment.generic_vuc_provider_id + "&vt=" + environment.adult_vuc_rfv_id;
    
    console.log("VUC Now clicked (IPUC)");
    console.log(deepLink);
    window.location.href = deepLink;
  
  }

  vucNowAuth() {
    var deepLink = '';

    deepLink = environment.web_vuc_deep_link_base_url; // For web users, use the web deep link

    const age = sessionStorage.getItem("age");
    var ageNumber = age ? parseInt(age) : null;

    if (ageNumber != null) {
        deepLink += ageNumber < 18 
          ? environment.pediatric_vuc_prc_id
          : environment.adult_vuc_prc_id;
    } 
        
    console.log("VUC Now clicked (IPUC)");
    console.log(deepLink);
    window.location.href = deepLink;
  }

  onReserveMySpot () {
    const eptID = sessionStorage.getItem("eptID");
    if (eptID == null || eptID == undefined || eptID == "") {
      this.reserveNowUnAuth();
    }
    else {
      this.reserveNowAuth();
    }
  }

  reserveNowUnAuth() {
    var deepLink = environment.web_unauth_omw_deep_link_base_url + this.location.departmentId;

    this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'search', subfeature: 'location-search', platform: 'web' }); // log as web event
    
    var searchMethod = sessionStorage.getItem('locationSearchMethod') ?? "unknown";
    
    if (searchMethod === 'quickSearch') {
      deepLink += "&linksource=PLUALOCQSIPUCRESERVE";
    }

    console.log("reserve now clicked unauth (IPUC)");
    console.log(deepLink);
    

    window.location.href = deepLink;
  }
  
  reserveNowAuth() {
    var deepLink = environment.web_omw_deep_link_base_url + this.location.departmentId; // For web users, use the web deep link

    this.monitoringService.logEvent('Schedule', { feature: 'search', subfeature: 'location-search', platform: 'web' }); // log as web event
    
    var searchMethod = sessionStorage.getItem('locationSearchMethod') ?? "unknown";
    
    if (searchMethod === 'quickSearch') {
      deepLink += "&linksource=AUTHHMLOCQSUCRESERVE";
    }

    console.log("reserve now clicked auth (IPUC)");
    console.log(deepLink);   

    window.location.href = deepLink;
  }

  hasStatus(): boolean {
    return this.location?.isOpen === false || this.location?.waitTime != null || this.location?.nextAvailability != null;
  }

  handleAction(event: Event): void {
    event.stopPropagation();
    
    const actionType = this.getActionType();
    if (actionType === 'virtual') {
      // Handle virtual care
      console.log('Opening virtual care...');
      this.onVirtualCareBtnClicked();
    } else if (actionType === 'reserve') {
      // Handle reservation
      console.log('Reserving spot...');
      this.onReserveMySpot();
    } else {
      // Handle view details
      this.viewLocationDetails();
    }
  }

  viewLocationDetails() {
    console.log('Viewing details for location:', this.location);

    window.scrollTo({ top: 50, behavior: 'smooth' });

    this.searchState.setCurrentLocationDetails(this.location);
    this.searchState.setShowSpinner(true);

    var locationDetailsRequest = new PostGetLocationDetailsRequest();
    locationDetailsRequest.locationID = this.location.locationId;
    locationDetailsRequest.cityOrZip = this.queryCityOrZip;
    locationDetailsRequest.latitude = this.currentLocation?.latitude || null;
    locationDetailsRequest.longitude = this.currentLocation?.longitude || null;

    this.mcAppGateway.PostGetLocationDetails(locationDetailsRequest).subscribe({
      next: (response) => {
        console.log('Location Details Response:', response);
        
        // Handle the response as needed
        this.searchState.setCurrentLocationDetails(response);
        this.searchState.setShowSpinner(false);
      },
      error: (error) => {
        console.error('Error fetching location details:', error);
        alert('An error occurred while fetching location details. Please try again later.');
        this.searchState.setShowSpinner(false);
        this.searchState.clearCurrentLocationDetails();
      }
    });
  }

  onGetDirections() {
    if (this.location && this.location.locationDirection) {
      window.open(this.location.locationDirection, '_blank');
    }
  }
}